import s from '../../styles/components/story/Team.module.css';

export default function Team({ data }) {
  const { image, imageCaption } = data;

  return (
    <section className={s.section}>
      <div className={s.imageWrap}>
        <img src={image} alt={imageCaption} className={s.image} />
        {imageCaption && <p className={s.caption}>{imageCaption}</p>}
      </div>
    </section>
  );
}